<template>
  <div class="m3">
    <div v-if="!openForm">
      <div class="p3 white-bg ">
        <span class="flex  h5n ">{{ getReferencelabel("IMPORT_BOOKINGS_TEXT") }}. </span>
        <div class="flex flex-wrap justify-center mt3">
          <Button reference="ADD_BOOKING" class="col-8 md-col-6 lg-col-4 " btn-color="red" :action="handleOpenForm" />
        </div>
      </div>
      <div class="p3 white-bg flex my3 justify-center">
        <span>{{ getReferencelabel("BOOKING_TEXT") }} <a
          class="underline pointer"
          href="/reservation/paiementsolde"
          target="blank"
        >{{ getReferencelabel("CLICK_HERE")
        }}</a>.</span>
      </div>
    </div>
    <div v-else>
      <div class="p3 white-bg ">
        <span class="col-12 block h4n bold">  {{ getReferencelabel('VISIT_DETAILS') }}</span>
        <div v-show="showMessage" class="mt2 danger">
          <span>{{ statusMessage }}</span>
        </div>
        <GenerateForm
          class="p0 m0"
          :form="form"
          :data="data"
          :save-action="importBooking"
          clear-data="true"
          :button-name="getReferencelabel('CONTINUE')"
        />
        <span class="flex flex-auto h5n mb3">{{ getReferencelabel("IMPORT_BOOKINGS_HELP")
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Button from '@/components/elements/Button';
import GenerateForm from '@/components/common/GenerateForm';
import { getReferencelabel } from '@/mixins/utils';
import { addVisibleOrder } from '@/mixins/requests';

export default {

  components: { Button, GenerateForm },
  setup () {
    const store = useStore();
    const router = useRouter();

    const userUuid = ref(store.state.user.uuid);
    const openForm = ref(false);

    const data = reactive({ bookingnumber: null, clientReference: null });
    const form = ref([
      [
        {
          reference: 'CLIENT_REFERENCE',
          id: 'clientReference',
          type: 'number',
          class: 'col-12 sm-col-6',
          required: true,
          placeholder: 'ex: 6641323'
        },
        {
          reference: 'BOOKING_NUMBER',
          id: 'bookingnumber',
          type: 'text',
          class: 'col-12 sm-col-6',
          required: true,
          placeholder: 'ex: 789789/1234/SI/WEB'
        }
      ]
    ]);

    const statusMessage = ref('');
    const showMessage = computed(() => !!statusMessage.value);

    const handleOpenForm = () => {
      console.log(openForm.value);
      openForm.value = !openForm.value;
    };

    async function importBooking () {
      statusMessage.value = '';
      store.commit('setLoading', true);
      const response = await addVisibleOrder(data.bookingnumber, userUuid.value, data.clientReference);
      Object.assign(data, { bookingnumber: null, clientReference: null });
      store.commit('setLoading', false);
      if (response && !response.success) {
        statusMessage.value = getReferencelabel('ERROR_INFORMATION');
        return;
      }
      router.push({ name: 'Reservations' });
    }

    return { data, form, openForm, getReferencelabel, showMessage, statusMessage, handleOpenForm, importBooking };
  }
};
</script>

<style lang="scss">
</style>
